var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-card"},[_c('div',{staticClass:"card col-md-6"},[_c('h3',[_vm._v("Alăptarea")]),_c('p',[_vm._v("este cea mai bună hrană care îi asigură bebelușului anticorpii de care are nevoie în primele 6 luni de viață. ")])])])
}]

export { render, staticRenderFns }